/**
 * @file The CSS custom properties the form page chrome publishes to its subtree.
 * `FormPage` sets `navbHeight`/`navbWidth` on its `FlexPage` from the measured
 * Navb box; the sticky form header in `FormPageContent` reads them. `FormPageContent`
 * sets `pageChromeHeight` (Navb plus its own measured header), read through
 * `PAGE_CHROME_STICKY_TOP` by ArTable, and `formContentMaxWidth`, read by
 * `ContainerUI`, `AttachmentList`, `ArTableBody` (card mode) and
 * `RelationshipTree` (below `md`). `EmbeddedEntityUI` resets
 * `formContentMaxWidth` to `100%` inside its record box, so the embedded
 * layout caps against that box rather than the page. Every reader supplies a
 * fallback, so a page that never sets a property (the Entities page) keeps its
 * fixed layout.
 */
export const FORM_PAGE_CSS_VARS = {
  navbHeight: '--navb-height',
  navbWidth: '--navb-width',
  pageChromeHeight: '--page-chrome-height',
  formContentMaxWidth: '--form-content-max-width',
} as const;
